// extracted by mini-css-extract-plugin
export default {"c4Box":"C4_c4Box__QnbTK","textBox":"C4_textBox__5eL8J"};